import esContent from './marketing.es';

export default {
  ...esContent,
};
